import { CardContent, Separator } from '@ais-ui/ui-core';
import React from 'react';

export interface TooltipFieldDefinition {
  key: string;
  label: string;
  value: string | number | undefined | null;
  visible: boolean | undefined | null;
}

interface InfoTooltipItemProps {
  label: string;
  value: string;
  fallback?: string;
  gap?: string;
}

const InfoTooltipItem = ({
  label,
  value,
  fallback = '-',
  gap = 'gap-2',
}: InfoTooltipItemProps) => (
  <div className={`grid grid-cols-[1fr_auto] ${gap} max-w-[12rem]`}>
    <p className="text-xs font-medium flex-none text-left max-w-[6rem]">
      {label}
    </p>
    <p className="text-xs text-muted-foreground flex-grow text-right">
      {value ? value : fallback}
    </p>
  </div>
);

interface InfoTooltipFieldsProps {
  fields: TooltipFieldDefinition[];
  fallback?: string;
  gap?: string;
}

export const InfoTooltipFields = ({
  fields,
  fallback = '-',
  gap = 'gap-2',
}: InfoTooltipFieldsProps) => {
  const visibleFields = fields.filter((f) => f.visible && f.value);

  if (visibleFields.length === 0) {
    return null;
  }

  return (
    <CardContent className="pt-0 pb-2 -mt-1 space-y-2 px-3">
      <Separator className="-ml-1" />
      <div className="grid grid-cols-[auto_auto] gap-x-4 gap-y-1">
        {visibleFields.map((field) => (
          <InfoTooltipItem
            key={field.key}
            label={field.label}
            value={String(field.value)}
            fallback={fallback}
            gap={gap}
          />
        ))}
      </div>
    </CardContent>
  );
};
